import { Badge } from "@/components/ui/badge";
import { Briefcase } from "lucide-react";

interface SpecialtiesSectionProps {
  specialties: string[];
}

export function SpecialtiesSection({ specialties }: SpecialtiesSectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Briefcase className="h-5 w-5" />
        <h2 className="text-xl font-semibold">Especialidades</h2>
      </div>
      <div className="flex flex-wrap gap-2">
        {specialties?.map((specialty, index) => (
          <Badge key={index} variant="secondary">
            {specialty}
          </Badge>
        ))}
      </div>
    </div>
  );
}